import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';

/**
 * FoF Forum Widgets (fof/forum-widgets-core) only renders its widget sections
 * on the index route, and FoF Categories strips the index sidebar on its
 * pages. Show the widgets on the categories and tags pages too.
 *
 * Registered as its own initializer with a negative priority, so it runs
 * after FoF Categories' initializer, which loads after this extension.
 */
const ROUTES = ['categories', 'tags'];
const SECTIONS = ['TopWidgetSection', 'BottomWidgetSection', 'EndWidgetSection', 'StartTopWidgetSection', 'StartBottomWidgetSection'];
const onWidgetRoute = () => ROUTES.includes(app.current.get('routeName'));
export default function extendWidgets() {
  if (!('fof-forum-widgets-core' in flarum.extensions)) return;
  const sections = {};
  for (const name of SECTIONS) {
    const section = flarum.reg.get('fof-forum-widgets-core', `forum/components/${name}`);
    if (!section) return;
    sections[name] = section;

    // Sections bail out unless the route is "index": let them render here too.
    override(section.prototype, 'view', function (original) {
      if (!onWidgetRoute()) return original();
      const routeName = app.current.get('routeName');
      app.current.set('routeName', 'index');
      try {
        return original();
      } finally {
        app.current.set('routeName', routeName);
      }
    });
  }

  // Runs after FoF Categories' sidebar cleanup (see the initializer priority).
  extend(IndexSidebar.prototype, 'items', function (items) {
    if (!onWidgetRoute()) return;
    const widgets = app.widgets;
    if (widgets.get('start_top').length && !items.has('startTopWidgetSection')) {
      items.add('startTopWidgetSection', m(sections.StartTopWidgetSection), 100);
    }
    if (widgets.get('start_bottom').length && !items.has('startBottomWidgetSection')) {
      items.add('startBottomWidgetSection', m(sections.StartBottomWidgetSection), -100);
    }
  });
}